import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - Shwapno Energy`;
  }, [title]);
}

export default useTitle;
